function isOnline() {
    const isOnline = window.navigator.onLine;
    return isOnline;
}

export default isOnline;
